module.exports = __webpack_public_path__ + "img/transparenciaTwo_one.ee791786.png";